import {Provider} from '@angular/core';
import {ClientHttpProvider} from '@shared/infrastructure/http/client.http.provider';
import {LocalStorageAdapterProvider} from '@shared/infrastructure/storage/local/local.storage.adapter.provider';

import {
  ListCitiesHttpAdapter
} from '@features/setting/infrastructure/http/list-cities/list-cities.http.adapter';
import {NavigationAdapterProvider} from '@shared/infrastructure/navigation/navigation.adapter.provider';
import {
  ListCitiesUseCasePort
} from '@features/setting/application/use_cases/list-cities/list-cities.use-case.port';

export const ListCitiesHttpProvider: Provider[] = [
  ClientHttpProvider,
  LocalStorageAdapterProvider,
  NavigationAdapterProvider,
  {
    provide: ListCitiesUseCasePort,
    useClass: ListCitiesHttpAdapter
  }
];
